import { render, staticRenderFns } from "./EditAtividade.vue?vue&type=template&id=76635b8a"
import script from "./EditAtividade.vue?vue&type=script&lang=js"
export * from "./EditAtividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports